import * as React from "react";

import "./import-target-area.scss";

import {ComponentLink,
        Link,
        makeChain}     from "@Common/react/cst2";
import {UseState}      from "@Common/react/use-state";
import {Types}         from "@Common/types";

import {ImportTargetSurface} from "./import-target-surface";
import {LoadingSpinner}      from "./loading-spinner";

export const ImportTargetArea = ({
    surfaceData,
    onApplyImage,
    dragImageRef,
    numSurfacesToDisplay  = 2 // TODO: Make this usable - Will not render correctly if using a different value because related CSS needs to adjust accordingly
}:{
    surfaceData           : Types.Common.Tools.CcIntegration.Models.ProductSurfaceWithImages[],
    onApplyImage          : Types.Common.UiComponents.PhotoDashboard.Functions.OnApplyImageForImport,
    dragImageRef          : Types.Common.React.UseRef.UseRefNext,
    numSurfacesToDisplay ?: number,
}) => (

    makeChain<JSX.Element>()

    // set state vars
    .then("state", (_, next:ComponentLink<typeof UseState<{
        currentSurfaceIndex  : number,
    }>>) => UseState({
        defaultValue: {
            currentSurfaceIndex: 0
        },
        next,
    }))

    // load the surfaces to display
    .then("displayedSurfaces", ({state}, next:Link<JSX.Element, Types.Common.Tools.CcIntegration.Models.ProductSurfaceWithImages[]>) => {

        // gather the number of surfaces to display, plus the surface before and after, to use for dimmed display at the edges
        let surfaces = surfaceData?.slice(
            state.value.currentSurfaceIndex ? state.value.currentSurfaceIndex - 1 : 0,
            state.value.currentSurfaceIndex + numSurfacesToDisplay + 1
        );

        // if showing the first surface, add 1st blank element to use as placeholder
        if (surfaces && !state.value.currentSurfaceIndex) surfaces.unshift(null);
        // if showing the last surface, add last blank element to use as placeholder
        if (surfaces && state.value.currentSurfaceIndex + numSurfacesToDisplay >= surfaceData.length) surfaces.push(null);

        return next(surfaces);

    })

    .then(({state, displayedSurfaces}) => (
        <div className="import-target-area-pl3">
            {!surfaceData && (
                <LoadingSpinner text="Loading Preview"/>
            )}
            <div className="surfaces">
                {/* show displayed surfaces with the first and last dimmed */}
                {displayedSurfaces && displayedSurfaces.map((surface, index) => (
                    <ImportTargetSurface
                        key={surface ? surface.name : "placeholder"+index}
                        surface={surface}
                        onApplyImage={onApplyImage}
                        dragImageRef={dragImageRef}
                        dimmed={index === 0 || index === numSurfacesToDisplay + 1}
                    />
                ))}
            </div>

            {surfaceData && state.value.currentSurfaceIndex > 0 && (
                <button className="button-back fa fa-arrow-left"
                    xd-qa-type="icon" xd-qa-name="ccimport modal target surface navigation back"
                    onClick={() => state.onChange({...state.value, currentSurfaceIndex: state.value.currentSurfaceIndex - 1})}
                ></button>
            )}
            {surfaceData && state.value.currentSurfaceIndex + numSurfacesToDisplay < surfaceData.length && (
                <button className="button-next fa fa-arrow-right"
                    xd-qa-type="icon" xd-qa-name="ccimport modal target surface navigation next"
                    onClick={() => state.onChange({...state.value, currentSurfaceIndex: state.value.currentSurfaceIndex + 1})}
                ></button>
            )}

        </div>
    ))

    .run()

);
